import getDecimalValue from './get-decimal-value'

/**
 * Formats the amount with prefixed "$".
 * Non-number and non-finite amount will be handled as 0.
 * @param {number|string} amount - Amount to be formatted
 * @param {boolean} [removeTrailingZeros=false] - Flag to remove trailing zeros. ex "$1.00" -> "$1"
 * @param {boolean} [thousandsSeparator=false] - Flag to format the values as. ex "$1000.00" -> "$1,000.00"
 * @param {number} [decimals=2] - amount of decimals.
 */
const formatCurrency = (amount, removeTrailingZeros = false, thousandsSeparator = false, decimals = 2) => {
  const decimalValue = getDecimalValue(amount)

  const isNegative = decimalValue.isNegative()

  let formattedAmount = decimalValue.absoluteValue().toFixed(decimals)

  if (removeTrailingZeros) {
    formattedAmount = parseFloat(formattedAmount).toString()
  }

  if (thousandsSeparator) {
    let formatter
    if (removeTrailingZeros) {
      formatter = new Intl.NumberFormat('en-US')
    } else {
      formatter = Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    }
    formattedAmount = formatter.format(formattedAmount)
  }

  return `${isNegative ? '-' : ''}$${formattedAmount}`
}

export default formatCurrency
